import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import Clients from "pages/Clients";
import ClientsDetail from "pages/Clients/detail";
import ClientsSubscription from "pages/Clients/subscription";
import ClientsTicket from "pages/Clients/ticket";
import ClientsMessages from "pages/Clients/messages";
import ClientInbox from "pages/Clients/clientInbox";
import UserProfile from "../pages/Authentication/user-profile";
import Teams from "pages/Teams";
import Billings from "pages/Billings";
import InvoiceDetail from "pages/Billings/invoice-detail";
import AdminSubscriptionPlans from "pages/subscription-plans";
import Logs from "pages/Logs";
import LogDetail from "pages/Logs/detail";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";


//Seting Pages

import ContactLevel from "pages/settings/contact-level";
import ContactStatus from "pages/settings/contact-status";
import ContactType from "pages/settings/contact-type";
import LeadSource from "pages/settings/lead-source";
import LeadStatus from "pages/settings/lead-status";
import LeadType from "pages/settings/lead-type";
import LeadStage from "pages/settings/lead-stage";
import ProjectStatus from "pages/settings/project-status";
import ProjectType from "pages/settings/project-type";
import TransactionType from "pages/settings/transaction-type";
import TransactionStatusType from "pages/settings/transaction-status";
import ListingType from "pages/settings/listing-type";
import ListingStatus from "pages/settings/listing-status";
import ServiceType from "pages/settings/service-type";
import DealChecklist from "pages/settings/deal-checklist";
import Currency from "pages/settings/currency";
import EmailTargetList from "pages/settings/email-target-list";
import EmailListType from "pages/settings/email-list-type";
import EmailTargetType from "pages/settings/email-target-type";
import EmailTargetSubType from "pages/settings/email-target-subtype";
import FieldDefinition from "pages/settings/field-defination";
import FieldValue from "pages/settings/field-value";
import HelpCategory from "pages/settings/help-category";
import LocalizationResource from "pages/settings/localization";
import PotentialListingStatus from "pages/settings/potentail-listing-status";
import ShowingStatus from "pages/settings/showing-status";
import SocialMediaLinkType from "pages/settings/social-media";
import SupportTicketStatus from "pages/settings/support-ticket-status";
import SupportTicketType from "pages/settings/support-ticket-type";
import EmailDisclaimerTemplateSingle from "pages/settings/email-disclamer";
import EmailTemplate from "pages/settings/email-notification";
import ActionPlanEmails from "pages/settings/action-plan-emails";
import TimeZoneMaster from "pages/settings/system-timezone";
import AgentTimeZone from "pages/settings/time-zone";
import TransactionRef from "pages/settings/transaction-ref";
import QuestionMaster from "pages/settings/question-answer";
import Role from "pages/Role/role";
import MasterLandingPageList from "pages/Master/master-landing-page";
import MasterLandingCreate from "pages/Master/master-landing-create";
import MasterLandingEdit from "pages/Master/master-landing-edit";
import OnBoarding from "pages/OnBoarding/on-boarding";
import ActionPlanFolders from "pages/ActionPlans";
import ActionPlanList from "pages/ActionPlans/plans";


const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/clients", component: <Clients /> },
  { path: "/client/:id", component: <ClientsDetail /> },
  { path: "/client/subscription", component: <ClientsSubscription /> },
  { path: "/client/support-ticket", component: <ClientsTicket /> },
  { path: "/client/messages", component: <ClientsMessages /> },
  { path: "/client/emails", component: <ClientInbox /> },
  { path: "/teams", component: <Teams /> },
  { path: "/billing", component: <Billings /> },
  { path: "/invoice-detail", component: <InvoiceDetail /> },
  { path: "/subscription-plans", component: <AdminSubscriptionPlans /> },
  { path: "/master-landing-page/create", component: <MasterLandingCreate /> },
  { path: "/master-landing-page/edit/:id", component: <MasterLandingEdit /> },
  { path: "/master-landing-page", component: <MasterLandingPageList /> },
  { path: "/on-boarding", component: <OnBoarding /> },
  { path: "/action-plans", component: <ActionPlanFolders /> },
  { path: "/action-plans/:categoryId", component: <ActionPlanList /> },
  {path: "/logs-audits", component: <Logs />},
  {path: "/logs/detail", component: <LogDetail />},
  { path: "/setting/contact-level", component: <ContactLevel /> },
  { path: "/setting/contact-status", component: <ContactStatus /> },
  { path: "/setting/contact-type", component: <ContactType /> },
  { path: "/setting/lead-source", component: <LeadSource /> },
  { path: "/setting/lead-status", component: <LeadStatus /> },
  { path: "/setting/lead-type", component: <LeadType /> },
  { path: "/setting/lead-stage", component: <LeadStage /> },
  {path: "/setting/project-status", component: <ProjectStatus />},
  {path: "/setting/project-type", component: <ProjectType />},
  {path: "/setting/transaction-type", component: <TransactionType />},
  {path: "/setting/transaction-status", component: <TransactionStatusType />},
  {path: "/setting/listing-type", component: <ListingType />},
  {path: "/setting/listing-status", component: <ListingStatus />},
  {path: "/setting/service-type", component: <ServiceType />},
  {path: "/setting/deal-checklist", component: <DealChecklist />},
  {path: "/setting/currency", component: <Currency />},
  {path: "/setting/email-target-list", component: <EmailTargetList />},
  {path: "/setting/email-list-type", component: <EmailListType />},
  {path: "/setting/email-target-type", component: <EmailTargetType />},
  {path: "/setting/email-target-subtype", component: <EmailTargetSubType />},
  {path: "/setting/field-definition", component: <FieldDefinition />},
  {path: "/setting/field-value", component: <FieldValue />},
  {path: "/setting/help-category", component: <HelpCategory />},
  {path: "/setting/localization", component: <LocalizationResource />},
  {path: "/setting/potential-listing-status", component: <PotentialListingStatus />},
  {path: "/setting/showing-status", component: <ShowingStatus />},
  {path: "/setting/social-media", component: <SocialMediaLinkType />},
  {path: "/setting/support-ticket-status", component: <SupportTicketStatus />},
  {path: "/setting/support-ticket-type", component: <SupportTicketType />},
  {path: "/setting/email-disclamer", component: <EmailDisclaimerTemplateSingle />},
  {path: "/setting/email-notification-templates", component: <EmailTemplate />},
  {path: "/setting/webflow-emails/action-plan-emails", component: <ActionPlanEmails />},
  {path: "/setting/system-timezone", component: <TimeZoneMaster />},
  {path: "/setting/agent-timezone", component: <AgentTimeZone />},
  {path: "/setting/transaction-ref", component: <TransactionRef />},
  {path: "/setting/question-answer", component: <QuestionMaster />},
  {path: "/setting/role", component: <Role />},



  // //profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
